// 主人公の歩きを作り直した比較版 (2026-10-12・DEV ?lunaWalk=new|newslow|newspeed|v2)。 既定 = 7 版目 a (2026-10-13 配布版へ・旧の歩きは ?lunaWalk=old)。
//   ユーザー「歩きに関してはもっさりしてる」「現状のLUNAIREは完全に足だけで歩いてる感じがして違和感なのかなと思っている。上半身が動いてないのが変というか」
//   見本 = Lies of P の走り (横から) ＋形「A 構えたままの早歩き」(速さ 150〜170px/秒・1歩 64〜70px・上体を少し前へ・腕を揺らす・
//   足を 12px 上げる・動き出しに一瞬の加速・止まる時に1歩・足の滑りなし)。 記録 = docs/research/2026-10-12-lunaire-walk-new.md
//
//   new      = 速さ 160px/秒・動き出しの加速 0.07 秒・新しい歩きの絵 (walk_n / walk_back_n)・止まる時の1歩
//   newslow  = 絵だけ新しい (速さ 120px/秒のまま・加速と止まる時の1歩は new と同じ)
//   newspeed = 速さだけ 160px/秒 (絵・加速なし・止まり方は今のまま)
//   v2       = new と同じ速さ・加速・止まる時の1歩・脚で、上半身を大きく動かした絵 (walk_v2 / walk_back_v2)。
//              騎士と亡霊の歩く速さも上げる (lunaWalkBossWalkMul・下がる主人公 160 に追いつける速さ)。 記録 = docs/research/2026-10-12-lunaire-walk-v2.md
//   v3       = 軽い小走り (2026-10-13・ユーザーの答え「A 軽い小走り (リリィ型・速さ160)」)。 速さ 160・加速・止まる時の1歩・足の滑りなしは v2 と同じ作り。
//              脚は走りの運び (両足が浮く間がある・WALK_V3)。 腰は踏んだ所で一番低く、浮いた所で高い (gaitPoseOf の run)。
//              絵 walk_v3 / walk_back_v3 = scripts/author_player_walk_v3.ts。 騎士と亡霊は v2 と同じく速くする。 記録 = docs/research/2026-10-13-lunaire-walk-v3.md
//   v4run    = 4 版目の走り (2026-10-13・3 版目「中腰」「すり足」「せかせか」を受けて作り方を変えた)。 見本 R1 (ZZZ 星見雅) のコマから読んだ鍵の姿勢を
//              滑らかにつなぐ (src/player_walk_v4.ts の V4_RUN)。 速さ 160・1歩 0.33 秒・両足が浮く間で進み、腰は立ち姿とほぼ同じ高さ。 騎士と亡霊は v3 と同じ。
//   v4walk   = 4 版目の歩き (見本 Z3・Z1・V4_WALK)。 速さは脚の長さで決めた 110 (130 では両足が着く所で腰が 5px 以上沈む)。
//              騎士と亡霊は主人公との速さの比を v3 と同じにする。 絵 = scripts/author_player_walk_v4.ts。 記録 = docs/research/2026-10-13-lunaire-walk-v4.md
//   v5       = 5 版目の歩き (2026-10-13・v4walk の「膝のあたりで関節がハマってないみたいにカクカク」「重み？がいる」を受けて)。 速さ 110。
//              膝の曲げを鍵にして腰を計算で出す (src/player_walk_v5.ts の V5_WALK)。 騎士と亡霊は「追いつかれるまでの秒」を v3 に合わせて下げた (V5_BOSS_WALK_MUL)。
//              絵 = scripts/author_player_walk_v5.ts。 記録 = docs/research/2026-10-13-lunaire-walk-v5.md
//   v6a|v6b|v6c = 6 版目の歩き (2026-10-13・v5 の「足だけで歩いてる感じがある」「重すぎる・もっさり」を受けて)。 速さ 110・騎士と亡霊は v5 と同じ。
//              v6a = 上半身が脚に合わせて動く (肩の線が回る・空いた手は置き場所のまま)・v6b = v6a ＋ 空いた手を振る・
//              v6c = 重心の乗り移り (1 歩 0.43 秒・腰の前後の揺れ)。 脚と腰 = src/player_walk_v6.ts・絵 = scripts/author_player_walk_v6.ts。
//              記録 = docs/research/2026-10-13-lunaire-walk-v6.md
//   v7a|v7b  = 7 版目の歩き (2026-10-13・v6 の「手がずっと前に出てるのが変」「まだ重い・130とかが良いかな？」を受けて)。 速さ 130 (src/player_walk_v7.ts)。
//              v7a = 空いた手を体の横に下ろして足と逆に振る・v7b = 剣を腰の前へ構え、空いた手は腰の後ろへ引く。 絵 = scripts/author_player_walk_v7.ts。
//              騎士と亡霊は「下がり続けて追いつかれるまでの秒」を 5 版目と同じに合わせ直した (V7_BOSS_WALK_MUL)。 記録 = docs/research/2026-10-13-lunaire-walk-v7.md
//
//   足の滑りを 0 にする作り: 歩きの絵の時計を「経過時間」ではなく「進んだ距離」で進める (render.ts)。 絵は 160px/秒で
//   作ってあり、1歩 = 66px の間に着いている足が体に対して 66px 後ろへ流れる = 床に対しては動かない。 速さが変わっても
//   (加速の途中・newslow の 120px/秒) 1歩の長さは同じで、足の回転だけが遅くなる。
//   絵は scripts/author_player_walk_new.ts がこのファイルの gait を使って骨のキーへ焼く (同じ式を止まる時の1歩でも使う)。
//
//   このファイルは描画にもゲームの判定にも使う = Spine を import しない (テストから読める)。
import { v4CycleSec, v4Pose, v4StepPx, V4_RUN, V4_WALK, type V4Gait } from './player_walk_v4'
import { v5CycleSec, v5Pose, v5StepPx, V5_WALK, type V5Gait } from './player_walk_v5'
import { V6_WALK, V6C_WALK } from './player_walk_v6'
import { V7_WALK } from './player_walk_v7'

export type LunaWalkVariant = 'off' | 'new' | 'newslow' | 'newspeed' | 'v2' | 'v3' | 'v4run' | 'v4walk' | 'v5' | 'v6a' | 'v6b' | 'v6c' | 'v7a' | 'v7b'
/** 既定 = 7 版目 a (2026-10-13 ユーザー採用・配布版)。 旧の歩きは ?lunaWalk=old ('off') */
const DEFAULT_VARIANT: LunaWalkVariant = 'v7a'
let variant: LunaWalkVariant = DEFAULT_VARIANT
export function setLunaWalkVariant(v: string | null): void {
  variant = v === 'new' || v === 'newslow' || v === 'newspeed' || v === 'v2' || v === 'v3' || v === 'v4run' || v === 'v4walk' || v === 'v5' || v === 'v6a' || v === 'v6b' || v === 'v6c' || v === 'v7a' || v === 'v7b' ? v : v === 'old' || v === 'off' ? 'off' : DEFAULT_VARIANT
}
export function lunaWalkVariant(): LunaWalkVariant { return variant }
const isV4 = () => variant === 'v4run' || variant === 'v4walk'
/** 6 版目 (v6a / v6b / v6c)。 騎士と亡霊・止まる時の1歩の扱いは 5 版目と同じ */
const isV6 = () => variant === 'v6a' || variant === 'v6b' || variant === 'v6c'
/** 7 版目 (v7a / v7b・速さ 130)。 止まる時の1歩の扱いは 5 版目と同じ・騎士と亡霊は V7_BOSS_WALK_MUL */
const isV7 = () => variant === 'v7a' || variant === 'v7b'
/** 鍵の姿勢で作った版 (4 版目〜7 版目)。 速さ・加速・絵・止まる時の1歩の扱いは同じ */
const isKeyed = () => isV4() || variant === 'v5' || isV6() || isV7()
/** 新しい歩きの絵・止まる時の1歩を使うか */
export function lunaWalkNewArt(): boolean { return variant === 'new' || variant === 'newslow' || variant === 'v2' || variant === 'v3' || isKeyed() }
/** 動き出しの加速を付けるか */
export function lunaWalkAccel(): boolean { return variant === 'new' || variant === 'newslow' || variant === 'v2' || variant === 'v3' || isKeyed() }
/** 歩く速さを上書きする時の値 (px/秒)。 off = null (player_locomotion_trial の今の速さ) */
export function lunaWalkSpeedOverride(): number | null {
  if (isKeyed()) return lunaWalkGait().speedPxPerSec
  return variant === 'new' || variant === 'newspeed' || variant === 'v2' ? WALK_NEW.speedPxPerSec : variant === 'v3' ? WALK_V3.speedPxPerSec : variant === 'newslow' ? 120 : null
}
/** 今のスイッチで使う歩きの絵の名前 (v2 = 上半身を大きく動かした 2 版目・v3 = 軽い小走り・v4run / v4walk = 4 版目・それ以外 = 1 版目) */
export function lunaWalkAnimNames(): { forward: string, back: string } {
  if (variant === 'v6a') return WALK_V6A_ANIM
  if (variant === 'v6b') return WALK_V6B_ANIM
  if (variant === 'v6c') return WALK_V6C_ANIM
  if (variant === 'v7a') return WALK_V7A_ANIM
  if (variant === 'v7b') return WALK_V7B_ANIM
  return variant === 'v5' ? WALK_V5_ANIM : variant === 'v4run' ? WALK_V4RUN_ANIM : variant === 'v4walk' ? WALK_V4WALK_ANIM : variant === 'v3' ? WALK_V3_ANIM : variant === 'v2' ? WALK_V2_ANIM : WALK_NEW_ANIM
}
/** 今のスイッチの足運び (v3 = 小走り WALK_V3・v4run / v4walk = 鍵の姿勢 WALK_V4RUN / WALK_V4WALK・それ以外 = WALK_NEW) */
export function lunaWalkGait(): GaitSpec {
  if (variant === 'v6a' || variant === 'v6b') return WALK_V6
  if (variant === 'v6c') return WALK_V6C
  if (isV7()) return WALK_V7
  return variant === 'v5' ? WALK_V5 : variant === 'v4run' ? WALK_V4RUN : variant === 'v4walk' ? WALK_V4WALK : variant === 'v3' ? WALK_V3 : WALK_NEW
}
/** 今のスイッチの絵1周 (2歩) の長さ (秒) */
export function lunaWalkCycleSec(): number { return gaitCycleSec(lunaWalkGait()) }

/**
 * ?lunaWalk=v2|v3 の時だけ、ボスの歩く速さの倍率を上書きする (BOSS.walkSpeed 270 × 倍率)。 null = 上書きなし。
 *   主人公が 160px/秒で下がると、騎士と亡霊は追いつけない・詰められない (balance.ts「walkSpeed は プレイヤー後退を確実に上回らせる」)。
 *   配布版へ入れる時はこの2体を同じ便で直す前提の試し。 目安は「歩いている間の本当の速さ」(tests/player_walk_new.test.ts の walkPace):
 *   - 騎士: 一歩ずつ区切って歩く (src/knight_gait.ts) ので本当の速さは設定の約 8 割。 今 = 設定 148.5 → 本当 121 (下がる主人公 120 とほぼ同じ)。
 *           v2 = 設定 215 (0.796) → 本当 170 (下がる主人公 160 より +10)。 設定 170 のままだと本当 131 で、下がるだけで離れていく。
 *   - 亡霊: そのまま歩く。 今 162 (主人公 120 より +42) → v2 180 (160 より +20)。
 */
export const V2_BOSS_WALK_MUL: Readonly<Record<string, number>> = {
  'vigil-knight': 215 / 270,
  'nameless-shade': 180 / 270,
}
/**
 * v4walk (主人公 110px/秒) の騎士と亡霊: 主人公との速さの比を v3 (主人公 160 に騎士 設定 215・亡霊 180) と同じにする = 110 / 160 倍。
 *   騎士 設定 147.8 (本当の速さ 約 117)・亡霊 123.75。 v4run は速さ 160 なので v3 と同じ (V2_BOSS_WALK_MUL)。
 */
export const V4WALK_BOSS_WALK_MUL: Readonly<Record<string, number>> = {
  'vigil-knight': (215 * 110 / 160) / 270,
  'nameless-shade': (180 * 110 / 160) / 270,
}
/**
 * v5 (主人公 110px/秒) の騎士と亡霊。 v4walk は「速さの比」を v3 と同じにしたのに「追いつかれすぎる」と言われた (10-13 検収パック 1013c)。
 *   測ると、比が同じでも追いつかれ方は同じにならない: 騎士は1歩ずつ区切って歩き、槍の届く間合い (約 210px) が主人公の速さに関係なく一定なので、
 *   主人公が遅いほど「下がり続けても届かれる」始めの間合いが広がる (tests/player_walk_new.test.ts の chaseCatchSec)。
 *   そこで「下がり続けた時に追いつかれて攻撃が始まるまでの秒」を v3 (ちょうどいい) に合わせ、少しだけゆるめた: 騎士 設定 136・亡霊 120。
 */
export const V5_BOSS_WALK_MUL: Readonly<Record<string, number>> = {
  'vigil-knight': 136 / 270,
  'nameless-shade': 120 / 270,
}
/**
 * v7a / v7b (主人公 130px/秒) の騎士と亡霊。 5 版目の騎士 136・亡霊 120 は「ちょうどいい」(10-13 検収パック 1013d)。
 *   主人公が速くなると、同じ速さのボスには下がるだけで追いつかれにくくなる。 そこで「下がり続けた時に追いつかれて攻撃が始まるまでの秒」
 *   (始めの間合い 230〜400px を 10px おき・6 秒で打ち切り) が 5 版目とほぼ同じになる速さへ上げた: 騎士 設定 164・亡霊 140。
 *   騎士は 1 歩ずつ区切って歩くので速さに対して段がある: 164 で 18 通り中 11 通り追いつかれる (5 版目 13)・165 で 13 通りだが秒の合計が 5 版目より 4 秒短い。
 *   きつくならない側の 164 にした。 亡霊は 140 で 2 通り・秒の合計 105.5 (5 版目 2 通り・105.6)。
 */
export const V7_BOSS_WALK_MUL: Readonly<Record<string, number>> = {
  'vigil-knight': 164 / 270,
  'nameless-shade': 140 / 270,
}
export function lunaWalkBossWalkMul(bossId: string): number | null {
  if (isV7()) return V7_BOSS_WALK_MUL[bossId] ?? null
  if (variant === 'v5' || isV6()) return V5_BOSS_WALK_MUL[bossId] ?? null
  if (variant === 'v4walk') return V4WALK_BOSS_WALK_MUL[bossId] ?? null
  return variant === 'v2' || variant === 'v3' || variant === 'v4run' ? V2_BOSS_WALK_MUL[bossId] ?? null : null
}

/** 足運びの決まり (1 版目・2 版目 = WALK_NEW の歩き・3 版目 = WALK_V3 の小走り) */
export interface GaitSpec {
  speedPxPerSec: number, stepPx: number, liftPx: number, accelSec: number, stanceFrac: number
  hipLowUnits: number, hipHighUnits: number
  stopStepSec: number, stopSettleSec: number, stopSettleMinUnits: number
  /** walk = 足が開いた所で低く片足の真上で高い (1・2 版目) / run = 踏んだ真ん中で一番低く、浮いた所で高い (3 版目) */
  hipMode: 'walk' | 'run'
  /** run だけ: 振り出す足の高さの山の位置 (0〜1・小さいほど蹴り上げが早い)。 walk は使わない */
  liftPeak: number
  /** 4 版目だけ: 鍵の姿勢の足運び (src/player_walk_v4.ts)。 あれば gaitPoseOf はこちらを使う (上の式の値は止まる時の1歩だけが使う) */
  v4?: V4Gait
  /** 5 版目だけ: 膝の曲げを鍵にした歩き (src/player_walk_v5.ts)。 あれば gaitPoseOf はこちらを使う */
  v5?: V5Gait
}

export const WALK_NEW: GaitSpec = {
  /** 歩く速さ (px/秒)。 見本 A の 150〜170 の真ん中 */
  speedPxPerSec: 160,
  /** 1歩の長さ (px) = 片足が床に着いている間に体が進む距離。 見本 A の 64〜70 */
  stepPx: 66,
  /** 足を上げる高さ (px・1歩の真ん中) */
  liftPx: 12,
  /** 止まった所から速さに乗るまで (秒) */
  accelSec: 0.07,
  /** 着いた足が床に居る割合 (1周のうち・片足ぶん)。 0.5 = 両足が同時に浮く間も、同時に着く間もない (早歩きと小走りの間) */
  stanceFrac: 0.42,
  /** 足が開いた時 (1歩の着地の瞬間) に腰を下げる量 (Spine の単位)。 脚が届くための沈み */
  hipLowUnits: -115,
  /** 片足で体を真上に載せた瞬間の腰 (Spine の単位)。 構えたままなので立ち姿 (0) より少し低い */
  hipHighUnits: -25,
  /** 止まる時の1歩: 浮いている足 (または後ろに残った足) を寄せる時間 (秒) */
  stopStepSec: 0.11,
  /** 止まる時の1歩の後、着いていた足が立ち姿の位置から離れすぎていたら寄せ直す時間 (秒) */
  stopSettleSec: 0.09,
  /** 寄せ直すかの境 (Spine の単位・約 4.5px) */
  stopSettleMinUnits: 60,
  hipMode: 'walk',
  liftPeak: 0.5,
}

/**
 * 3 版目の軽い小走り (?lunaWalk=v3)。 数字の元 = docs/research/2026-10-13-lunaire-walk-v3.md (ZZZ の武器を持った走りとリリィ)。
 *   速さ 160 はそのまま。 1歩 = stepPx / 160 秒。 片足が床に居るのは1周の stanceFrac (0.5 未満 = 両足が浮く間がある = 走り)。
 *   着地・離地の腰 = hipHighUnits (脚が前後の足へ届く高さ)・踏んだ真ん中で hipLowUnits まで沈み、浮いている間は投げ上げの弧でそれより上へ。
 */
export const WALK_V3: GaitSpec = {
  speedPxPerSec: 160,
  stepPx: 57.6,
  liftPx: 15,
  accelSec: 0.07,
  stanceFrac: 0.36,
  hipLowUnits: -90,
  hipHighUnits: -62,
  stopStepSec: 0.11,
  stopSettleSec: 0.09,
  stopSettleMinUnits: 60,
  hipMode: 'run',
  liftPeak: 0.42,
}

/** Spine の 1 単位が何 px か (skeleton の高さ 1581.73 を 120px で描く・src/spine_player.ts と同じ) */
export const SPINE_PX_PER_UNIT = 120 / 1581.7297
/** 足運び1周 (2歩) の長さ (秒) */
export function gaitCycleSec(g: GaitSpec): number { return (2 * g.stepPx) / g.speedPxPerSec }
/** 新しい歩き1周 (2歩) の長さ (秒)。 絵はこの長さで 2歩 = 132px 進む前提で作る */
export const WALK_NEW_CYCLE_SEC = gaitCycleSec(WALK_NEW)
/** 3 版目の小走り1周 (2歩) の長さ (秒) */
export const WALK_V3_CYCLE_SEC = gaitCycleSec(WALK_V3)
/** 体の根 (root) が −1.8° 傾いているぶん、足の的を前後へ動かすと床から浮き沈みする。 その打ち消し (y 単位 / x 単位) */
const ROOT_TILT = Math.tan(1.798802 * Math.PI / 180)

export interface FootKey { x: number, y: number }
export interface GaitPose { front: FootKey, back: FootKey, hipY: number, frontStance: boolean, backStance: boolean }

const smooth = (t: number) => t * t * (3 - 2 * t)
const wrap01 = (p: number) => ((p % 1) + 1) % 1

/** 1本の足の前後 (px・前 = +) と高さ (px)。 p = その足の位相 (0 = 床に着いて体の真下を過ぎる瞬間) */
function footPx(G: GaitSpec, p: number): { fwd: number, lift: number, stance: boolean } {
  // 床に着いている間 (1周の f) に体は f × 2歩 進む = 足は体に対して ±A を流れる
  const f = G.stanceFrac
  const A = f * G.stepPx
  const q = wrap01(p + f / 2)   // 0 = 着地の瞬間
  if (q < f) {
    // 床に着いている: 体に対して前 A → 後ろ A へ一定の速さで流れる (= 床に対しては止まっている)
    return { fwd: A - (2 * A) * (q / f), lift: 0, stance: true }
  }
  // 浮いている: 後ろ A → 前 A。 速さは真ん中で一番速く、着地の前に少し緩む。 高さは真ん中で liftPx
  const s = (q - f) / (1 - f)
  if (G.hipMode === 'walk') return { fwd: -A + 2 * A * smooth(s), lift: G.liftPx * Math.sin(Math.PI * s) ** 1.3, stance: false }
  // 小走り: 蹴った足は先に上へ巻き上がり (高さの山が前寄り = liftPeak)、前へ運んでから下ろす
  const sp = s < G.liftPeak ? 0.5 * s / G.liftPeak : 0.5 + 0.5 * (s - G.liftPeak) / (1 - G.liftPeak)
  return { fwd: -A + 2 * A * smooth(s), lift: G.liftPx * Math.sin(Math.PI * sp) ** 1.15, stance: false }
}

/** px (前 = +・上 = +) → 足の的の translate (Spine の単位・setup からの差)。 人形は左向きに作られていて前 = −x */
export function footPxToUnits(fwdPx: number, liftPx: number): FootKey {
  const x = -fwdPx / SPINE_PX_PER_UNIT
  return { x, y: liftPx / SPINE_PX_PER_UNIT + x * ROOT_TILT }
}

/**
 * 新しい歩きの脚と腰 (位相 phase 0〜1・1周で2歩)。 dir = 1 前へ歩く・−1 後ろへ歩く (後ろ歩きは時間を逆に流した形)。
 *   位相 0 = 手前の足 (front) が床に着いて体の真下を過ぎる瞬間・奥の足 (back) は振り出しの真ん中 (一番高い)。
 *   立ち姿からはこの姿へ混ぜて入る (手前の足はほぼ立ち姿の位置・奥の足は上がるだけ) ので、歩き出しで足が滑りにくい。
 */
export function gaitPose(phase: number, dir: 1 | -1 = 1): GaitPose { return gaitPoseOf(WALK_NEW, phase, dir) }

/**
 * 小走りの腰の上下の形 (0 = 着地・離地の高さ・−1 = 一番沈む・正 = 浮き)。 u = 1歩の中の位置 (0 = 片足が体の真下を過ぎる瞬間・1 で次の足)。
 *   踏んでいる間はばねのように沈んで戻り (真ん中が一番低い)、浮いている間は投げ上げの弧 (真ん中が一番高い)。
 *   踏む→浮くの境で上下の速さがつながるよう浮きの高さを決める = 波の形が上下で違う (下は広く丸い・上は短い)。
 */
export function runHipShape(G: GaitSpec, u: number): number {
  const st = 2 * G.stanceFrac            // 1歩のうち踏んでいる割合
  const fl = 1 - st                      // 浮いている割合
  const w = wrap01(u + st / 2)           // 0 = 着地
  if (w < st) return -Math.sin(Math.PI * w / st)
  const t = (w - st) / fl
  const up = Math.PI * fl / (4 * st)     // 速さがつながる浮きの高さ (沈み 1 に対して)
  return up * 4 * t * (1 - t)
}

/** 足運び G の脚と腰 (gaitPose の中身。 3 版目の小走りも同じ式で、着いた足は床に対して動かない) */
export function gaitPoseOf(G: GaitSpec, phase: number, dir: 1 | -1 = 1): GaitPose {
  if (G.v5 || G.v4) {
    const g = G.v5 ? v5Pose(G.v5, phase, dir) : v4Pose(G.v4!, phase, dir)
    return { front: g.front.ik, back: g.back.ik, hipY: g.hipY, frontStance: g.front.stance, backStance: g.back.stance }
  }
  const p = dir === 1 ? phase : -phase
  const fr = footPx(G, p)
  const bk = footPx(G, p + 0.5)
  // 後ろ歩きは時間を逆に流すだけ (着いた足は体に対して前へ流れる = 体が後ろへ進む)
  const front = footPxToUnits(fr.fwd, fr.lift)
  const back = footPxToUnits(bk.fwd, bk.lift)
  if (G.hipMode === 'run') {
    // 小走りの腰: 着地・離地 = hipHighUnits・踏んだ真ん中 (足が体の真下) = hipLowUnits・浮いている間はそれより上
    const hipY = G.hipHighUnits + (G.hipHighUnits - G.hipLowUnits) * runHipShape(G, 2 * p)
    return { front, back, hipY, frontStance: fr.stance, backStance: bk.stance }
  }
  // 腰: 片足の真上 (位相 0・0.5) で高く、足が開いた着地 (0.25・0.75) で低い
  const c = (1 + Math.cos(4 * Math.PI * phase)) / 2
  const hipY = G.hipLowUnits + (G.hipHighUnits - G.hipLowUnits) * c
  return { front, back, hipY, frontStance: fr.stance, backStance: bk.stance }
}

/** 加速を付けた歩きの速さ (px/秒・符号つき)。 prev = 前の tick の速さ・moveX = 入力 (−1/0/1)・target = 目標の速さ */
export function nextWalkVelocity(prev: number, moveX: number, target: number, dtSec: number): number {
  if (moveX === 0) return 0   // 離したら体はすぐ止まる (止まる時の1歩は絵だけ・操作の手応えを鈍らせない)
  const want = moveX * target
  const base = Math.sign(prev) === Math.sign(moveX) ? prev : 0
  const step = target * dtSec / lunaWalkGait().accelSec
  return moveX > 0 ? Math.min(want, base + step) : Math.max(want, base - step)
}

// ---- 止まる時の1歩 (描くだけ) ----
export interface StopPlan {
  /** 止まった瞬間の足の的 (Spine の単位) */
  front: FootKey, back: FootKey, hipY: number
  /** 先に寄せる足 (止まった時に浮いていた方・両方着いていれば後ろに残った方) */
  first: 'front' | 'back'
  /** 2歩目 (残った足の寄せ直し) をするか */
  settle: boolean
  /** 始まってからの秒 */
  t: number
  /** 途中で別の動きへ移った時、上書きを消していく重み (1 → 0) */
  fade: number
  fading: boolean
  /** 足運びの決まり (省略 = WALK_NEW) */
  gait?: GaitSpec
}

export function makeStopPlan(phase: number, dir: 1 | -1, G: GaitSpec = WALK_NEW): StopPlan {
  const g = gaitPoseOf(G, phase, dir)
  // 浮いている足を先に寄せる。 両方とも床なら、立ち姿の位置から遠い方を先に
  let first: 'front' | 'back'
  if (!g.frontStance) first = 'front'
  else if (!g.backStance) first = 'back'
  else first = Math.abs(g.front.x) >= Math.abs(g.back.x) ? 'front' : 'back'
  const other = first === 'front' ? g.back : g.front
  // 4 版目は床に居る足も踵を上げて (足首が床から上がって) いることがある → 上がっていたら寄せ直す
  const raised = G.v4 || G.v5 ? (other.y - other.x * ROOT_TILT) * SPINE_PX_PER_UNIT > 1.5 : false
  return { front: g.front, back: g.back, hipY: g.hipY, first, settle: Math.abs(other.x) > G.stopSettleMinUnits || raised, t: 0, fade: 1, fading: false, ...(G === WALK_NEW ? {} : { gait: G }) }
}

export function stopPlanDuration(plan: StopPlan): number {
  const G = plan.gait ?? WALK_NEW
  return G.stopStepSec + (plan.settle ? G.stopSettleSec : 0)
}

/** 1本の足を from から立ち姿 (0,0) へ弧を描いて運ぶ。 s = 0〜1・liftUnits = 弧の高さ */
function carry(from: FootKey, s: number, liftUnits: number): FootKey {
  const e = smooth(Math.max(0, Math.min(1, s)))
  const arc = Math.sin(Math.PI * Math.max(0, Math.min(1, s))) * liftUnits
  return { x: from.x * (1 - e), y: from.y * (1 - e) + arc }
}

export interface StopPose {
  front: FootKey, back: FootKey
  /** 腰の上下 (Spine の単位・setup からの差)。 アニメの値 animHipY より低い時だけ使う (脚が届くため) */
  hipYMax: number
  /** 胴を前へ足す角度 (度)。 止まる瞬間に上体が慣性で少し前へ流れて戻る */
  torsoAdd: number
  /** 0〜1。 1 = 上書きを全部効かせる */
  weight: number
}

/** 止まる時の1歩のその時刻の姿。 null = 終わった */
export function stopPose(plan: StopPlan): StopPose | null {
  const G = plan.gait ?? WALK_NEW
  const T1 = G.stopStepSec
  const total = stopPlanDuration(plan)
  if (plan.t >= total || plan.fade <= 0) return null
  const firstFrom = plan.first === 'front' ? plan.front : plan.back
  const otherFrom = plan.first === 'front' ? plan.back : plan.front
  // 床に着いていた足なら弧を描いて持ち上げる。 もう浮いている足は今の高さから下ろしながら寄せる
  const firstNow = carry(firstFrom, plan.t / T1, firstFrom.y > 20 ? 0 : (G.liftPx * 0.6) / SPINE_PX_PER_UNIT)
  const otherNow = plan.settle && plan.t > T1
    ? carry(otherFrom, (plan.t - T1) / G.stopSettleSec, (G.liftPx * 0.35) / SPINE_PX_PER_UNIT)
    : otherFrom
  // 脚が届くよう、離れている足ほど腰を下げる (歩きの着地の沈み hipLowUnits で ±33px が届く・小走りは着地の高さ hipHighUnits で届く)
  const far = Math.max(Math.abs(firstNow.x), Math.abs(otherNow.x)) * SPINE_PX_PER_UNIT / (G.stanceFrac * G.stepPx)
  const reachHip = G.hipMode === 'run' ? G.hipHighUnits : G.hipLowUnits
  const hipYMax = reachHip * Math.min(1, far * far)
  // 上体の慣性: 0.05 秒で一番前へ (+4°)、1歩の終わりまでに戻る
  const k = plan.t / T1
  const torsoAdd = k < 1 ? 4 * Math.sin(Math.PI * Math.min(1, k)) * (1 - 0.3 * k) : 0
  return {
    front: plan.first === 'front' ? firstNow : otherNow,
    back: plan.first === 'front' ? otherNow : firstNow,
    hipYMax, torsoAdd, weight: plan.fade,
  }
}

/** 描画側の1コマ分の進め方。 dt = 描画の秒 */
export function advanceStopPlan(plan: StopPlan, dt: number, stillNeutral: boolean): StopPlan | null {
  const fading = plan.fading || !stillNeutral
  const next = { ...plan, t: plan.t + dt, fading, fade: fading ? plan.fade - dt / 0.06 : plan.fade }
  return stopPose(next) ? next : null
}

/** 新しい歩きの絵の名前 */
export const WALK_NEW_ANIM = { forward: 'walk_n', back: 'walk_back_n' } as const
/** 2 版目の絵の名前 (?lunaWalk=v2・scripts/author_player_walk_v2.ts が焼く)。 脚・腰・1周の長さは 1 版目と同じ */
export const WALK_V2_ANIM = { forward: 'walk_v2', back: 'walk_back_v2' } as const
/** 3 版目 (軽い小走り) の絵の名前 (?lunaWalk=v3・scripts/author_player_walk_v3.ts が焼く)。 脚と腰 = gaitPoseOf(WALK_V3) */
export const WALK_V3_ANIM = { forward: 'walk_v3', back: 'walk_back_v3' } as const

/**
 * 4 版目 (?lunaWalk=v4run|v4walk) の足運び。 脚と腰は v4 (鍵の姿勢) が決める。 ここの数字は速さ・1歩・止まる時の1歩のためのもの
 *   (stepPx = 速さ × 1歩の時間 = 絵の時計を進んだ距離で進める長さ・hipHighUnits = 止まる時の1歩で脚が届く腰)。
 */
function v4Spec(G: V4Gait, liftPx: number, hipHighUnits: number): GaitSpec {
  return {
    speedPxPerSec: G.speedPxPerSec, stepPx: v4StepPx(G), liftPx, accelSec: 0.07, stanceFrac: G.stanceFrac,
    hipLowUnits: hipHighUnits, hipHighUnits, stopStepSec: 0.11, stopSettleSec: 0.09, stopSettleMinUnits: 60,
    hipMode: 'run', liftPeak: 0.5, v4: G,
  }
}
export const WALK_V4RUN: GaitSpec = v4Spec(V4_RUN, 10, -20)
export const WALK_V4WALK: GaitSpec = v4Spec(V4_WALK, 6, -40)
/** 4 版目の1周 (2歩) の長さ (秒) */
export const WALK_V4RUN_CYCLE_SEC = v4CycleSec(V4_RUN)
export const WALK_V4WALK_CYCLE_SEC = v4CycleSec(V4_WALK)
/** 4 版目の絵の名前 (scripts/author_player_walk_v4.ts が焼く) */
export const WALK_V4RUN_ANIM = { forward: 'walk_v4run', back: 'walk_back_v4run' } as const
export const WALK_V4WALK_ANIM = { forward: 'walk_v4walk', back: 'walk_back_v4walk' } as const

/**
 * 5 版目 (?lunaWalk=v5) の足運び。 脚と腰は v5 (膝の曲げの鍵) が決める。 止まる時の1歩は 4 版目と同じ扱い。
 */
export const WALK_V5: GaitSpec = {
  speedPxPerSec: V5_WALK.speedPxPerSec, stepPx: v5StepPx(V5_WALK), liftPx: 6, accelSec: 0.07, stanceFrac: V5_WALK.stanceFrac,
  hipLowUnits: -40, hipHighUnits: -40, stopStepSec: 0.11, stopSettleSec: 0.09, stopSettleMinUnits: 60,
  hipMode: 'run', liftPeak: 0.5, v5: V5_WALK,
}
export const WALK_V5_CYCLE_SEC = v5CycleSec(V5_WALK)
/** 5 版目の絵の名前 (scripts/author_player_walk_v5.ts が焼く) */
export const WALK_V5_ANIM = { forward: 'walk_v5', back: 'walk_back_v5' } as const

/**
 * 6 版目 (?lunaWalk=v6a|v6b|v6c) の足運び。 v6a / v6b の脚と腰は 5 版目と同じ (V6_WALK = V5_WALK)・v6c は 1 歩 0.43 秒＋腰の前後の揺れ (V6C_WALK)。
 *   止まる時の1歩は 5 版目と同じ扱い。 違いは絵 (上半身) だけ = scripts/author_player_walk_v6.ts。
 */
export const WALK_V6: GaitSpec = { ...WALK_V5, v5: V6_WALK }
export const WALK_V6C: GaitSpec = { ...WALK_V5, stepPx: v5StepPx(V6C_WALK), v5: V6C_WALK }
/** 6 版目の絵の名前 (scripts/author_player_walk_v6.ts が焼く) */
export const WALK_V6A_ANIM = { forward: 'walk_v6a', back: 'walk_back_v6a' } as const
export const WALK_V6B_ANIM = { forward: 'walk_v6b', back: 'walk_back_v6b' } as const
export const WALK_V6C_ANIM = { forward: 'walk_v6c', back: 'walk_back_v6c' } as const

/**
 * 7 版目 (?lunaWalk=v7a|v7b) の足運び。 速さ 130・1 歩 0.41 秒 (V7_WALK)。 止まる時の1歩は 5 版目と同じ扱い。
 *   v7a と v7b の違いは絵 (上半身) だけ = scripts/author_player_walk_v7.ts。
 */
export const WALK_V7: GaitSpec = { ...WALK_V5, speedPxPerSec: V7_WALK.speedPxPerSec, stepPx: v5StepPx(V7_WALK), stanceFrac: V7_WALK.stanceFrac, v5: V7_WALK }
export const WALK_V7_CYCLE_SEC = v5CycleSec(V7_WALK)
/** 7 版目の絵の名前 (scripts/author_player_walk_v7.ts が焼く) */
export const WALK_V7A_ANIM = { forward: 'walk_v7a', back: 'walk_back_v7a' } as const
export const WALK_V7B_ANIM = { forward: 'walk_v7b', back: 'walk_back_v7b' } as const

/**
 * 主人公の歩きが旧の速さ (120px/秒) より速い時の、戴冠獣の のしかかり (houndPounce) の跳びかかりの延長 (px)。
 *   下がり続ける主人公は、予備動作の開始から跳びかかりが着くまで (約 2.4 秒) に、速くなった分だけ余計に離れる。
 *   「予備動作の開始から下がり続けても被弾する」(tests/combat.test.ts) を保つため、その分だけ跳びかかりを延ばす
 *   (速さ 130 なら (130-120)×2.4 = 24px・旧の歩き ?lunaWalk=old は 0)。 当たりの大きさは変えない。
 */
export const POUNCE_CHASE_WINDOW_SEC = 2.4
export function lunaWalkPounceExtraPx(): number {
  const speed = lunaWalkSpeedOverride()
  return speed == null ? 0 : Math.max(0, Math.round((speed - 120) * POUNCE_CHASE_WINDOW_SEC))
}
